/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import * as ModelsFromStore  from '@apps-store/models';
import * as EnumsFromStore from '@apps-store/enums';
import { Dispatch } from 'redux';

import * as Utils from '@root-utils/index';

/**
 * @function StatsActionSuccess  - 
 * @return { object } payload
 * @returns { string }  type
 * @param { any } 
 */
export function StatsActionSuccess(data:any): ModelsFromStore.StatsActionSuccess {

    return {
        
        payload:{

            data,
            loading: false,
            

        },

        type :EnumsFromStore.StatsTypes.STATS_SUCCESS

    }
}

/**
 * @function StatsActionFail  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param { any } 
 */
export function StatsActionFail(errors: any): ModelsFromStore.StatsActionFail {

    return {
        payload:{

            error: errors  ,
            loading: false,
            
        },

        type :EnumsFromStore.StatsTypes.STATS_FAIL

    }
}
/**
 * @function StatsActionInProgress  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param {  } 
 */
export function StatsActionInProgress(): ModelsFromStore.StatsActionInProgress{

    return {
        payload:{

         
            loading: true,
            
        },

        type :EnumsFromStore.StatsTypes.STATS_INPROGRESS

    }
}

// CONSTRUCTEUR

/**
 * @function StatsActionCreator 
 * @param {  } 
 * @return {Promise<any>}  Promise
 */
export function StatsActionCreator():(dispatch: Dispatch<any>, {}) => Promise<any>{
 
    return  async (dispatch: Dispatch<any>) => {

        dispatch(StatsActionInProgress());

        await Utils.Stats()
            .then((res: any) => {
                if( res.ok ){ res.json().then( (data: any) => dispatch(StatsActionSuccess(data)))     
                }else{ dispatch(StatsActionFail("server error has occurred with HTTP status ("+res.status+ ")" ))}
            })
            .catch( (error : any) => dispatch(StatsActionFail(error)))  
    }
    
}  




// WEBPACK FOOTER //
// ./src/apps/store/action-creator/stats/index.ts